// const IntlFormattedMessage = require("react-intl").FormattedMessage;
import React, { useMemo } from 'react';
import { useTranslations } from 'next-intl';

const FormattedMessage = ({ id, classoverride, dynamic = false, values }) => {
	const translations = useTranslations();
	const message = useMemo(() => {
		if (dynamic) {
			return translations(id, values);
		}
		return translations.markup(id, {
			b: (chunks) => `<b>${chunks}</b>`,
		});
	}, [dynamic, values]);
	const classname = useMemo(
		() =>
			classoverride &&
			typeof classoverride === 'string' &&
			classoverride.trim().length > 0
				? classoverride
				: 'formatted-message',
		[classoverride]
	);

	return (
		<span
			className={classname}
			textid={id}
			dangerouslySetInnerHTML={{ __html: message }}
		/>
	);
};

export default FormattedMessage;
